"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aggregateDocuments = exports.cacheDocuments = exports.bulkWriteDocuments = exports.deleteDocument = exports.updateDocument = exports.createDocument = exports.fetchAllDocuments = exports.fetchOneDocument = exports.fetchDocuments = void 0;
var Config_1 = require("../Config");
var ApiUtil_1 = require("../Utils/ApiUtil");
var JStorageCompat_1 = require("./JStorageCompat");
function fetchDocuments(collection, query, sorting, paging, projection, options) {
  if (query === void 0) {
    query = {};
  }
  if (sorting === void 0) {
    sorting = [];
  }
  if (paging === void 0) {
    paging = {
      offset: 0,
      limit: 100
    };
  }
  if (projection === void 0) {
    projection = null;
  }
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/find", options.anonymous, options.token), {
            method: 'POST',
            data: __assign(__assign({
              query: JStorageCompat_1._convertQuery(query),
              // make sure we always sort the records with desc _id
              sorting: !sorting ? ['-_id'] : __spreadArray(__spreadArray([], sorting), ['-_id'])
            }, paging ? {
              paging: paging
            } : {}), projection ? {
              projection: projection
            } : {})
          })];
        case 1:
          resp = _a.sent();
          if (resp.results) {
            return [2 /*return*/, __assign(__assign({}, resp), {
              results: resp.results.map(JStorageCompat_1._convertDocument)
            })];
          } else {
            return [2 /*return*/, resp.map(JStorageCompat_1._convertDocument)];
          }
          return [2 /*return*/];
      }
    });
  });
}

exports.fetchDocuments = fetchDocuments;
function fetchAllDocuments(collection, query, sorting, projection, options) {
  if (query === void 0) {
    query = {};
  }
  if (sorting === void 0) {
    sorting = [];
  }
  if (projection === void 0) {
    projection = null;
  }
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/find", options.anonymous, options.token), {
            method: 'POST',
            data: __assign({
              query: JStorageCompat_1._convertQuery(query),
              // make sure we always sort the records with desc _id
              sorting: !sorting ? ['-_id'] : __spreadArray(__spreadArray([], sorting), ['-_id'])
            }, projection ? {
              projection: projection
            } : {})
          })];
        case 1:
          resp = _a.sent();
          return [2 /*return*/, resp.map(JStorageCompat_1._convertDocument)];
      }
    });
  });
}
exports.fetchAllDocuments = fetchAllDocuments;
function cacheDocuments(collection, query, sorting, paging, projection, options, cacheOptions) {
  if (query === void 0) {
    query = {};
  }
  if (sorting === void 0) {
    sorting = [];
  }
  if (paging === void 0) {
    paging = {
      offset: 0,
      limit: 100
    };
  }
  if (projection === void 0) {
    projection = null;
  }
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/cache", options.anonymous, options.token), {
            method: 'POST',
            data: __assign(__assign(__assign({
              query: JStorageCompat_1._convertQuery(query),
              // make sure we always sort the records with desc _id
              sorting: !sorting ? ['-_id'] : __spreadArray(['-_id'], sorting)
            }, paging ? {
              paging: paging
            } : {}), projection ? {
              projection: projection
            } : {}), {
              key: cacheOptions.key,
              acl: cacheOptions.acl || 'public-read'
            })
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.cacheDocuments = cacheDocuments;
function fetchOneDocument(collection, query, projection, options) {
  if (query === void 0) {
    query = {};
  }
  if (projection === void 0) {
    projection = null;
  }
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/find-one", options.anonymous, options.token), {
            method: 'POST',
            data: __assign({
              query: JStorageCompat_1._convertQuery(query)
            }, projection ? {
              projection: projection
            } : {})
          })];
        case 1:
          resp = _a.sent();
          return [2 /*return*/, JStorageCompat_1._convertDocument(resp)];
      }
    });
  });
}
exports.fetchOneDocument = fetchOneDocument;
function createDocument(collection, data, options) {
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var nextDoc;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/create", options.anonymous, options.token), {
            method: 'POST',
            data: {
              data: data
            }
          })];
        case 1:
          nextDoc = _a.sent();
          return [2 /*return*/, JStorageCompat_1._convertDocument(nextDoc)];
      }
    });
  });
}
exports.createDocument = createDocument;
function updateDocument(collection, query, data, options) {
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    var anonymous, token, restOptions, nextDoc;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          anonymous = options.anonymous, token = options.token, restOptions = __rest(options, ["anonymous", "token"]);
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/update", anonymous, token), {
            method: 'POST',
            data: {
              query: JStorageCompat_1._convertQuery(query),
              data: data,
              option: __assign({}, restOptions)
            }
          })];
        case 1:
          nextDoc = _a.sent();
          return [2 /*return*/, JStorageCompat_1._convertDocument(nextDoc)];
      }
    });
  });
}
exports.updateDocument = updateDocument;
function deleteDocument(collection, query, options) {
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/find-one/delete", options.anonymous, options.token), {
            method: 'POST',
            data: {
              query: JStorageCompat_1._convertQuery(query)
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.deleteDocument = deleteDocument;
function bulkWriteDocuments(collection, operations, options) {
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/bulk-write", options.anonymous, options.token), {
            method: 'POST',
            data: {
              actions: operations
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.bulkWriteDocuments = bulkWriteDocuments;
function aggregateDocuments(collection, operations, options) {
  if (options === void 0) {
    options = {
      anonymous: false,
      token: ''
    };
  }
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(_appendToken(Config_1.get().jstoreHost + "/document/" + collection + "/aggregate", options.anonymous, options.token), {
            method: 'POST',
            data: {
              data: operations
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.aggregateDocuments = aggregateDocuments;
/**
 * **************************************************
 * Helpers
 * **************************************************
 */
function _appendToken(url, anonymous, token) {
  var _a;
  if (!token) {
    token = (_a = Config_1.get().UserOutlet.getValue()) === null || _a === void 0 ? void 0 : _a.token;
    // it also might be undefined, by anonymous = true
  }

  var separator = '?';
  // TODO: find better way for this
  if (url.indexOf('?') > -1) {
    separator = '&';
  }
  if (token && token.indexOf('tmp_') !== 0 && !anonymous) {
    return url + (separator + "token=" + token);
  } else {
    return url + (separator + "client_id=" + Config_1.get().clientId);
  }
}